import { useEffect, useState } from 'react';

export interface ElementSize {
  width: number;
  height: number;
}

const useElementSize = (element: HTMLElement | null) => {
  const [size, setSize] = useState<ElementSize>({ width: 0, height: 0 });

  useEffect(() => {
    if (!element) {
      return;
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];

      if (!entry) {
        return;
      }

      const { width, height } = entry.contentRect;

      setSize((currentSize) =>
        currentSize.width === width && currentSize.height === height
          ? currentSize
          : { width, height },
      );
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, [element]);

  return size;
};

export default useElementSize;
